enum SortDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}

export default SortDirection;
